<template>
  <div class="carbonfootprint-wapper">
    <e-title :title="title" v-bind="$attrs" v-on="$listeners">
      <slot name="title"></slot>
      <div slot="content">
        <slot></slot>
      </div>
    </e-title>
    <!-- <div class="wappercontent">
      <slot></slot>
    </div> -->
  </div>
</template>

<script>
import eTitle from '@/components/common/e-title.vue';
export default {
  name: 'CarbonfootprintWapper',
  components: {
    eTitle,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.carbonfootprint-wapper {
  width: 100%;

  .wappercontent {
    border: 1px solid rgba(217, 217, 217, 1);
    border-top: none;
    padding: 20px;
  }
}
</style>
